// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1VHOu","question":"Question_question___IT3Z","description":"Question_description__2rgrC"};